module.exports = __webpack_public_path__ + "static/media/icon_menu_invoice_active.2da4aeb9.svg";